import { fields, zodValidator } from '@codeleap/form'
import { form } from '@codeleap/form'
import { ChatUser } from '@packages/chat'
import z from 'zod'

export const chatGroup = form('chat', {
  name: fields.text({
    placeholder: 'Add your group name (optional)',
    label: 'Group name',
    validate: zodValidator(
      z.string()
        .trim()
        .max(24, 'Group name must be 24 characters or fewer')
        .optional(),
    ),
  }),
  members: fields.list(
    { defaultValue: [], item: {} as ChatUser },
  ),
  file: fields.file({}),
})
